import Campaigns from './campaignsResource';
import errorTransformer from '@/api/shared/transformers/errorTransformer';
import parseRange from '@/api/shared/utility/parseRange';
import transformToCamelCase from '@/api/shared/transformers/toCamelCaseTransformer';
import transformCSV from '@/api/shared/transformers/CSVTransformer';
import normalizeNumbers from '@/utils/normalizeNumbers';

function getCampaigns({ range, page, pageSize }) {
  return Campaigns.get({
    ...parseRange(range),
    page,
    per_page: pageSize,
  })
    .then(({ body: campaigns }) => campaigns)
    .catch(errorTransformer);
}

function getCampaignInfo(campaignId) {
  return Campaigns.get({ campaignId })
    .then(({ body: campaignInfo }) => transformToCamelCase(campaignInfo))
    .then(campaignInfo => ({
      ...campaignInfo,
      hasTracker: Boolean(campaignInfo.clickTrackerLink),
    }))
    .catch(errorTransformer);
}

function getCampaignStats(campaignId, range) {
  return Campaigns.getStats({
    campaignId,
    ...parseRange(range),
  })
    .then(({ body }) => body)
    .catch(errorTransformer);
}

function getCampaignReports(campaignId) {
  return Campaigns.getReports({ campaignId })
    .then(({ body }) => body)
    .catch(errorTransformer);
}

function saveCSV(campaignId, range) {
  return Campaigns.saveCSV({
    campaignId,
    ...parseRange(range),
  })
    .then(res => transformCSV(res))
    .catch(errorTransformer);
}

function updateCampaign({ campaignId, campaignInfo }) {
  return Campaigns.updateCampaign({ campaignId }, campaignInfo)
    .then(({ body: { message = '' } }) => message)
    .catch(errorTransformer);
}

function addCampaign(campaignData) {
  return Campaigns.save({}, normalizeNumbers(campaignData))
    .then(({ body: { message = '' } }) => {
      return message;
    })
    .catch(errorTransformer);
}

export default {
  getCampaigns,
  getCampaignInfo,
  getCampaignStats,
  getCampaignReports,
  saveCSV,
  updateCampaign,
  addCampaign,
};
